<div class="row edicao-dia-jornal"
  style="
    position: relative;
    background: url('images/bandeira-minas-gerais-header.png') no-repeat, linear-gradient(90deg, rgb(0, 0, 0, 0.7) 0%, rgb(0, 0, 0, 0.7) 20%, rgb(202, 202, 202, 0.1) 100%);
    background-size: cover;
    background-blend-mode: hue;
    background-position: 50% 50%;
    margin: 0;
  ">

  <span class="span-credito-foto">{{ creditoFoto }}</span>

  <div class="col-12 col-md-6 calendario-dropdown-column">
    <h1 class="titulo-edicao">Acesse a <br>edição do dia</h1>
    <app-dropdown-calendario [dataApresentada]="ultimaData" [Cronogramas]="cronogramas"
      (redirecionarUltimaEdicao)="goToUltimaEdicao()"
      (dataClicada)="obterData($event)" (alternarMes)="trocouMes($event)">
    </app-dropdown-calendario>
  </div>
  <div class="col-12 col-md-6">
    @if (dadosJornalHome?.edicaoOrdinaria; as edicaoOrdinaria) {
      @for (caderno of edicaoOrdinaria.cadernos; track caderno.cadernoEdicaoId) {
        <button type="button" class="card-edicao-dia"
          (click)="obterCadernoHome(edicaoOrdinaria, caderno)">
          <span class="edicao-caderno-descricao" style="color: black;">{{ caderno.descricao }}</span>
        </button>
      }
    } @else {
      @for (caderno of dadosJornalHome?.cadernosUltimaEdicao; track caderno.id) {
        <button type="button" class="card-edicao-dia" (click)="obterCadernoDoDia(caderno)">
          <span class="edicao-caderno-descricao" style="color: black;">{{ caderno.descricao }}</span>
        </button>
      }
    }
    @if (dadosJornalHome?.primeiraEdicaoExtra; as primeiraEdicaoExtra) {
      @if (primeiraEdicaoExtra.cadernos.length > 0) {
        <button type="button" class="card-edicao-dia"
          (click)="obterPrimeiraEdicaoExtra(primeiraEdicaoExtra)">
          <span class="edicao-caderno-descricao" style="color: black;">Edição Extra</span>
        </button>
      }
    }
  </div>
  <div class="div-credito-foto-mobile"><span class="span-credito-foto-mobile">{{ creditoFoto }}</span></div>
</div>
<div>
  <div class="search-bar-line-edicao-dia-bg">
    <lib-segov-sigepo-rounded-search-bar
      [class]="'spacing-search-bar'"
      (click)="showModalPesquisa()"
      (keyup.enter)="showModalPesquisa()"
      [style]="'width: 100%;'"
      [customSearchIconStyle]="'color: var(--tom-1-jornal); padding-right: 8px; font-size: 30px'"
      [customInputStyle]="'height: 72px; border-radius: 5px'" [placeholder]="'Clique aqui para efetuar a pesquisa avançada'">
    </lib-segov-sigepo-rounded-search-bar>
  </div>
</div>

<lib-segov-sigepo-modal
    [showModal]="exibeModalPesquisa"
    [maxWidthExterno]="'1080px'"
    [hasHeader]="false"
    [closeIconStyle]="'color:white'"
    [modalBodyStyle]="'padding: 0'"
    [modalCustomStyle]="'background-color: #231f209e;'"
    [showCloseIcon]="true"
    (closedModal)="exibeModalPesquisa = false">
    <app-segov-sigepo-pesquisa-form body
      (dadosPesquisaFormOutput)="goToPesquisa($event)"/>
</lib-segov-sigepo-modal>
